module.exports = __webpack_public_path__ + "img/three2Red.a2333ef4.jpg";